export class ItemEntity {
  codigo: number;
  descricao: string;
  novo?: boolean;

  constructor(init?: Partial<ItemEntity>) {
    Object.assign(this, init);
  }
}
